import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserListsDetailsColumnComponent } from './user-lists-details-column.component';

@Component({
  template: `
    <div class="user-list-name-column">
      {{ element.userName }}
    </div>
  `,
  styleUrls: ['../user-lists-details.component.scss'],
})
export class UserNameColumnComponent extends UserListsDetailsColumnComponent {
  constructor(private router: Router) {
    super();
  }

  editUser(): void {
    this.router.navigate(['bc-admin', 'user', this.element.userId, 'edit']);
  }
}
